<label [class.input-group]="hasIcon">
    {{label}}
    <span *ngIf="hasIcon" class="input-group-label"><ng-content select="[icon]"></ng-content></span>
    <div class="input">
        <textarea #input
                  (ngModelChange)="onChange($event)"
                  [class._delete]="delete"
                  [class._disabled]="disabled"
                  [class._search]="search"
                  [ngModel]="data" [placeholder]="placeholder"></textarea>
        <a (click)="onDelete()" *ngIf="delete" class="deleteIcon"><i class="fas fa-times-circle"></i></a>
    </div>
</label>
